import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Import correcto desde react-router-dom (el de 'react-router' puede romper el contexto y evitar rerenders en navegación)
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';


// 🧹 MIGRACIÓN: Limpiar tokens del sistema anterior
// Esto se ejecuta una sola vez al cargar la aplicación
(() => {
  const oldToken = localStorage.getItem('inoelec_admin_token');
  const newToken = localStorage.getItem('accessToken');

  if (oldToken && !newToken) {
    console.log('🔄 Migrando tokens del sistema anterior...');
    // Si solo hay tokens viejos, forzar logout para que el usuario vuelva a hacer login
    localStorage.removeItem('inoelec_admin_token');
    localStorage.removeItem('inoelec_admin_refresh_token');
    console.log(
      '✅ Tokens antiguos eliminados. Por favor, inicie sesión nuevamente.'
    );
  } else if (oldToken && newToken) {
    // Si hay ambos, eliminar los viejos
    console.log('🧹 Eliminando tokens duplicados...');
    localStorage.removeItem('inoelec_admin_token');
    localStorage.removeItem('inoelec_admin_refresh_token');
    console.log('✅ Tokens antiguos eliminados.');
  }
})();

// Create a client for react-query v3 (used by generated API hooks)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
